import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouteUser = () => {
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
  };

  return getCookie("auth") ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRouteUser;
